<template>
  <Button
    v-if="storeUrl"
    :href="`https://login.ratandboa.com/moas/broker/login/shopify/${storeUrl}/account?idpname=google_oauth`"
    tag="a"
    full-width
  >
    Continue with Google
  </Button>
</template>

<script>
import Button from "@/components/Button.vue";
export default {
  name: "GoogleSignOn",
  components: {
    Button,
  },
  data() {
    return {
      storeUrl: process.env.SHOPIFY_SSO_STORE_URL || null,
    };
  },
};
</script>
